export interface ValidationResult {
    reason?: string;
    resultType: ValidationResultType;
}

export enum ValidationResultType {
    PROCESS_RETRY,
    COMPONENT_RETRY,
    UPDATE_PASSWORD,
    UPDATE_USERNAME_PASSWORD,
    DONE
}
